// Ensure Amplify and other legacy browser dependencies that expect a Node-like
// `global` property can operate without relying on inline scripts in index.html.
if (typeof window !== "undefined") {
  const currentGlobal = (window as typeof window & { global?: typeof globalThis }).global;
  if (!currentGlobal) {
    (window as typeof window & { global?: typeof globalThis }).global = window;
  }
}
